const getRequiredEnv = (name, value) => {
	if (typeof value !== 'string' || value.trim() === '') {
		throw new Error(`Missing required environment variable: ${name}`);
	}
	return value;
};


export const clientId = getRequiredEnv('REACT_APP_CLIENT_ID', process.env.REACT_APP_CLIENT_ID);
export const tenant = getRequiredEnv('REACT_APP_TENANT', process.env.REACT_APP_TENANT);
export const baseURL = getRequiredEnv('REACT_APP_BASE_URL', process.env.REACT_APP_BASE_URL);
export const apiEndPoint = getRequiredEnv('REACT_APP_API_END_POINT', process.env.REACT_APP_API_END_POINT);
export const powerBiURL = getRequiredEnv('REACT_APP_POWERBI_URL', process.env.REACT_APP_POWERBI_URL);
